import request from 'utils/request';
import { basePaymentApiUrl } from '../constants';

export interface ReportParam {
    date_from: string | null;
    date_until: string | null;
    region_id: string | number | undefined;
    courier_id: string | number | undefined;
    user_id?: string | number | undefined;
}

export function fetchReportByCourier(
    url: string,
    config: { headers?: { [key: string]: string }; data: ReportParam | FormData }
): Promise<any> {
    return request(`/report/${url}`, {
        method: 'POST',
        responseType: 'arraybuffer',
        ...config,
    });
}

export function fetchPaymentsReport(data: any) {
    return request({
        url: '/report/completed-mobile-payment',
        method: 'post',
        data: data,
        responseType: 'arraybuffer',
        baseURL: basePaymentApiUrl,
    });
}
